import { Point } from './common-models';
import { IFiducialPoint, IPoint, IScaler } from '../models/interfaces';
import { line as d3Line, Line } from 'd3-shape';

export class FiducialPoint implements IFiducialPoint {
    // data members

    marker: string | null;
    public value: number;
    public scaler: IScaler;
    public scaleLine: any | null = null;
    private _marker = new Array<IPoint>();

    // constructor

    constructor(value: number, scaler: IScaler, height: number) {
        this.value = value;
        this.scaler = scaler;

        this._marker.push(new Point(value, height / 2 + 10));
        this._marker.push(new Point(value, height / 2 - 10));
        this.scaleLine = this.updateScale();
        this.marker = this.scaleLine(this._marker);
    }

    // public functions

    update() {
        this.scaleLine = this.updateScale();
        this.marker = this.scaleLine(this._marker);
    }

    // private functions

    private updateScale(): Line<IPoint> {
        return d3Line<IPoint>()
            .x((point: IPoint) => {
                return this.scaler.onX(point.x);
            })
            .y((point: IPoint) => {
                return point.y;
            });
    }
}
